import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHomeSlice } from 'app/pages/Home/slice';
import { selectUpdateSuccessAlert } from 'app/pages/Home/slice/selectors';

/** Mirrors TimelineCard temporary highlight after quick-edit PATCH success. */
export function useMonthlyUpdateSuccessHighlight(
  issueId: string | undefined,
  releasePhaseId?: string
): boolean {
  const { actions } = useHomeSlice();
  const dispatch = useDispatch();
  const updateSuccessAlert = useSelector(selectUpdateSuccessAlert);
  const [isTemporarilyHighlighted, setIsTemporarilyHighlighted] =
    useState(false);

  useEffect(() => {
    if (!updateSuccessAlert) {
      setIsTemporarilyHighlighted(false);
      return;
    }

    const alertIssueId = updateSuccessAlert.issueId;
    const alertPhaseId = updateSuccessAlert.releasePhaseId || null;

    const isMatch =
      alertIssueId === issueId &&
      (releasePhaseId
        ? alertPhaseId === releasePhaseId
        : alertPhaseId === null || alertPhaseId === '');

    if (isMatch) {
      setIsTemporarilyHighlighted(true);

      const clearTimer = setTimeout(() => {
        dispatch(actions.clearUpdateSuccessAlert());
      }, 3000);

      return () => clearTimeout(clearTimer);
    }
  }, [updateSuccessAlert, issueId, releasePhaseId, dispatch, actions]);

  return isTemporarilyHighlighted;
}
